import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResizeSyncService {
  sizeUpdated = new Subject<string>();

  constructor() {}
}
